import SharedSectionMenu from 'components/shared/SectionMenu';

import { SECTIONS_MENU } from 'views/home_form/constants';

const HomeSectionMenu = () => {
  return (
    <SharedSectionMenu
      sections={SECTIONS_MENU}
      formStateKey="homePersonalForm"
    />
  );
};

export default HomeSectionMenu;
